import Http from "../http";

class CityConfigServices{
    static async getCityConfig(){
        return Http.get('/getCityConfig');
    }
    
    static async updateCityCponfig(id,data){
        console.log("data in upodateCityConfig",data);
        return Http.update(`/editCityConfig/${id}`,data);
    }
    static async addCityConfig(data){
        console.log("========================================data in the riderServices",data)
        return Http.post('/addCityConfig',data)
    }
    static async deleteCityConfig(id){
        return Http.delete(`/deleteCityConfig/${id}`);
    }
    
}
export default CityConfigServices